<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <TrackersBatch />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import TrackersBatch from '@/components/settings/stock-registers/active/TrackersBatch'

export default {
  name: 'AddTrackersBatch',
  components: {
    PageTitle,
    PageRowWrapper,
    TrackersBatch
  }
}
</script>
